import React, { useState } from 'react';
import { Button, Card, Space, message, Tag, List } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import * as dd from 'dingtalk-jsapi';

const GroupChatSelector = ({ 
  selectedChats, 
  setSelectedChats, 
  corpId,
  loading = false
}) => {
  const [selectingChat, setSelectingChat] = useState(false);

  // 选择钉钉群聊
  const handleChooseChat = () => {
    setSelectingChat(true);
    
    // 确保在钉钉环境中并且API可用
    if (typeof dd !== 'undefined' && dd.env.platform !== 'notInDingTalk') {
      dd.ready(() => {
        dd.chooseChat({
          corpId: corpId, // 使用从App.js传递的企业ID
          isAllowCreateGroup: true,
          filterNotOwnerGroup: true,
          onSuccess: (res) => {
            const { title, chatId, openConversationId } = res;
            message.info(`选择的群聊: ${chatId}`);

            // 检查是否已经选择了这个群
            if (!selectedChats.find(chat => chat.chatId === chatId)) {
              setSelectedChats(prev => [...prev, {
                title,
                chatId,
                openConversationId,
                key: Date.now() + Math.random()
              }]);
              message.success(`已选择群聊: ${title}`);
            } else {
              message.warning('该群聊已选择');
            }
          },
          onFail: (err) => {
            console.error('选择群聊失败:', err);
            message.error(`选择群聊失败: ${err.errorMessage || err.message}`);
          }
        });
      });
    } else {
      message.error('钉钉环境未初始化，请在钉钉客户端中使用此功能');
      // 提供备用方案或提示
    }
    setSelectingChat(false);
  };

  // 移除已选择的群聊
  const handleRemoveChat = (chatKey) => {
    setSelectedChats(prev => prev.filter(chat => chat.key !== chatKey));
  };

  return (
    <Card 
      size="small" 
      title="将同步发布到群聊" 
      // extra={
      //   <Button 
      //     type="primary" 
      //     size="small" 
      //     icon={<PlusOutlined />}
      //     loading={selectingChat || loading}
      //     onClick={handleChooseChat}
      //   >
      //     选择群聊
      //   </Button>
      // }
      style={{marginBottom: 16}}

    >
      {selectedChats.length === 0 ? (
        <div style={{ color: '#999', textAlign: 'center', padding: '16px' }}>
          暂未选择群聊，点击上方按钮选择
        </div>
      ) : (
        <List
          size="small"
          dataSource={selectedChats}
          renderItem={(chat) => (
            <List.Item
              // actions={[
              //   <Button 
              //     type="text" 
              //     danger 
              //     size="small" 
              //     icon={<DeleteOutlined />}
              //     onClick={() => handleRemoveChat(chat.key)}
              //   />
              // ]}
            >
              <List.Item.Meta
                title={chat.title}
                // description={
                //   <Space>
                //     <Tag color="blue">ID: {chat.chatId}</Tag>
                //     <Tag color="green">会话ID: {chat.openConversationId?.substring(0, 10)}...</Tag>
                //   </Space>
                // }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default GroupChatSelector;